<!-- day :{{day}} - hour : {{hour}} - min : {{minute}} - sec : {{second}}
 -->

<div class="count-down">
	<div class="item">
		<div class="value">
			<div class="section-a">
				{{day[0]}}
			</div>
			<div class="section-b">
				{{day[1]}}
			</div>
		</div>
		<div class="label">
			{{'DASHBOARD.TRANSFORM.DAY' | translate}}
		</div>
	</div>
	<span></span>
	<div class="item">
		<div class="value">
			<div class="section-a">
				{{hour[0]}}
			</div>
			<div class="section-b">
				{{hour[1]}}
			</div>
		</div>
		<div class="label">
			{{'DASHBOARD.TRANSFORM.HOURS' | translate}}
		</div>
	</div>
	<span>:</span>
	<div class="item">
		<div class="value">
			<div class="section-a">
				{{minute[0]}}
			</div>
			<div class="section-b">
				{{minute[1]}}
			</div>
		</div>
		<div class="label">
			{{'DASHBOARD.TRANSFORM.MINUTE' | translate}}
		</div>
	</div>
	<span>:</span>
	<div class="item">
		<div class="value">
			<div class="section-a">
				{{second[0]}}
			</div>
			<div class="section-b">
				{{second[1]}}
			</div>
		</div>
		<div class="label">
			{{'DASHBOARD.TRANSFORM.SECOND' | translate}}
		</div>
	</div>
</div>
